<template>
  <div class="replys">
	    <div v-if="item.msg_content.reply!=''" class="replyBox">
	        <div class="replyItem" v-if="item.msg_content.reply.biz_type=='TEXT'">
	          <div class="replyName">{{item.msg_content.reply.nick_name}}</div>
	          <div class="replyCotent">{{item.msg_content.reply.msg_content.content}}</div>
	        </div>
	        <div class="replyItem" v-if="item.msg_content.reply.biz_type=='PIC_FILES'">
	          <img class="replyImg" :src="item.msg_content.reply.msg_content.images[0]" />
	          <div class="rons">
	            <div class="replyName">{{item.msg_content.reply.nick_name}}</div>
	            <div class="replyCotent">图片</div>
	          </div>
	        </div>
	        <div class="replyItem" v-if="item.msg_content.reply.biz_type=='PIC_FILE'">
	          <img class="replyImg" :src="item.msg_content.reply.msg_content.url" />
	          <div class="rons">
	            <div class="replyName">{{item.msg_content.reply.nick_name}}</div>
	            <div class="replyCotent row1">图片</div>
	          </div>
	        </div>
	        <div class="replyItem" v-if="item.msg_content.reply.biz_type=='VIDEO_FILE'">
	          <img class="replyImg" :src="item.msg_content.reply.msg_content.url+'?vframe/jpg/offset/1/w/60/h/60'">
	          <div class="rons">
	            <div class="replyName">{{item.msg_content.reply.nick_name}}</div>
	            <div class="replyCotent row1">视频</div>
	          </div>
	        </div>
	         <div class="replyItem" v-if="item.msg_content.reply.biz_type=='COUPON'">
	          <div class="replyName">{{item.msg_content.reply.nick_name}}</div>
	          <div class="replyCotent">优惠券</div>
	        </div>
	        <div class="replyItem" v-if="item.msg_content.reply.biz_type=='TLJ'">
	          <div class="replyName">{{item.msg_content.reply.nick_name}}</div>
	          <div class="replyCotent">淘红包</div>
	        </div>
	        <div class="replyItem" v-if="item.msg_content.reply.biz_type=='GOODS'">
	          <img class="replyImg" :src="item.msg_content.reply.msg_content.img" />
	          <div class="rons">
	            <div class="replyName">{{item.msg_content.reply.msg_from_nick}}</div>
	            <div class="replyCotent row1">{{item.msg_content.reply.msg_content.title}}</div>
	          </div>
	        </div>			
	        <div class="replyItem" v-if="item.msg_content.reply.biz_type=='MUSIC'">
	          <img class="replyImg" :src="item.msg_content.reply.msg_content.song_logo" />
	          <div class="rons">
	            <div class="replyName">{{item.msg_content.reply.msg_content.song_title}}</div>
	            <div class="replyCotent row1">{{item.msg_content.reply.msg_content.singer_title}}</div>
	          </div>
	        </div>
	        <div class="replyItem" v-if="item.msg_content.reply.biz_type=='CARD'">
	          <img class="replyImg" :src="item.msg_content.reply.msg_content.info.logo" />
	          <div class="rons">
	            <div class="replyName">{{item.msg_content.reply.msg_content.info.title}}</div>
	            <div class="replyCotent row1">{{item.msg_content.reply.msg_content.info.desc}}</div>
	          </div>
	        </div>

	        
	        
	        
	        
	        
	        
	        
	    </div>
  </div>
</template>

<script>
export default {
	props:["item"],
  data () {
    return {

    }
  },
  methods:{
  
  },
  created:function(){
 
  },
  filters:{
  	tows:function(data){
  		return (data/100).toFixed(2)
    },
    goodsCouponInfos:function(data){
    	if(data.length<=0){
    		return ''
    	}else{
    		var num=0
    		data.filter((item)=>{
    			if(num<item.coupon_discount){
    				num=item.coupon_discount
    			}
    		})
    		return num/100
    	}
    }
  }    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

/*sss*/
.replyBox{
 border-left: 2px #409EFF solid;
 padding-left: 10px;
}
.replyItem{
  font-size: 10px;
  overflow: hidden;
}
.replyName{
  font-size: 10px;
  line-height: 1;
  color: #409EFF;
}
.replyCotent{
  line-height: 1;
  font-size: 10px;
  width: 300px;
	overflow:hidden; 
	text-overflow:ellipsis; 
	white-space:nowrap; 
}
.replyImg{
  width: 30px !important;
  height: 30px !important;
  float: left;
  margin-right: 5px;
}
.rons{float: left;}
.replyvideo{
  width: 60px;
}

.huiFuXX{
  margin: 0  !important;
  margin: 0  !important;
  position: absolute;
  width: 100%  !important;
  height: 40px  !important;
  background: #ffffff  !important;
  top: -40px  !important;
  z-index: 10;
  border-radius: 0  !important;
  left: 0;
  overflow: hidden;
  padding: 10px;
  box-sizing: border-box;
}
.inputRoom .replyItem img{
  margin-left: 0 !important;
}
.close{ position: absolute;right:0;top: 0;height:40px;background: #ffffff;padding: 10px;padding-right: 15px;}
.close img{
  width: 20px;
  height: 20px;
}
.contentTLJ{
	background: #F56C6C !important;
	border-radius: 4px;
	overflow: hidden;
	width: 300px;
	box-sizing: border-box;
	padding: 0 !important;
	
}
.contentTLJ .name{
	text-align: center;
	padding: 8px 0;
	float: none !important;
	color: #ffffff;
	padding: 10px 15px;
	}
.contentTLJ .tt{
	background: #FFFFFF !important;
	padding:10px 10px;
	}
	
.yhq{padding-top: 50px;background: #F3F3F3;}
.yhq .box{
	background: url(../../assets/img/yhq2.png) 0 0 no-repeat;
	width: 250px;
	height: 120px;
	margin: auto;
	background-size: 100% 100%;
}
.yhq .name{
	line-height: 60px;
	text-align: center;
	color: #FFFFFF;
}
.yhq .tkl{
	line-height: 60px;
	text-align: center;
	color: #FE4F46;
}
.yhq .tt{
	color: #FE4F46;
	text-align: center;
	padding-top: 20px;
}


.goodsmy{}
.goodsmy img{width: 200px;}
.goodsmy .text{font-size:16px;font-weight: bold;}
.goodsmy h1{
	font-weight: normal;
	display: inline-block;
	font-size: 15px;
	color: red;
	line-height: 40px;
}
.goodsmy h1 label{}
.goodsmy h1 del{}
.goodsmy h1 span{}
.goodsmy h2{}
</style>



// WEBPACK FOOTER //
// src/components/im/reply.vue